



















































































import { Component, Vue } from "vue-property-decorator";
import DatePicker from "@/components/DatePicker.vue";
import moment from "moment";
import SitesAPI from "@/services/sites";
import Site from "@/models/site";
// TODO: Eliminar si ya no se usará
import VueApexCharts from "vue-apexcharts";
import DefinitionListSelector from "@/components/DefinitionListSelector.vue";
import SummaryTable from "./components/SummaryTable.vue";
import PeriodComparatorLegend from "./components/PeriodComparatorLegend.vue";
import { QueryParams } from "@/models/general";

@Component({
  components: {
    DatePicker,
    VueApexCharts,
    DefinitionListSelector,
    SummaryTable,
    PeriodComparatorLegend,
  },
})
export default class OccupancyReport extends Vue {
  dates: string[] = [];
  otherPeriod: string[] = [];
  sites: Site[] = [];
  rowDef = "";
  colDef = "";

  demoData = {
    chartData: {
      series: [44, 55, 13, 33],
      labels: ["Apple", "Mango", "Orange", "Watermelon"],
    },
  };

  created(): void {
    this.setDates();
    this.getData();
  }

  setDates(): void {
    const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
    const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
    this.dates.push(startOfMonth);
    this.dates.push(endOfMonth);
    this.otherPeriod.push(
      moment().startOf("month").subtract(1, "year").format("YYYY-MM-DD")
    );
    this.otherPeriod.push(
      moment().endOf("month").subtract(1, "year").format("YYYY-MM-DD")
    );
  }

  async getData(): Promise<void> {
    try {
      const params: QueryParams = {
        page: {
          number: -1,
        },
      };
      const r = await SitesAPI.getSites(params);
      this.sites = r.data;
      console.log(this.sites);
    } catch (e) {
      console.log(e);
    }
  }
}
